import { Queue as QueueType } from '@rossum/api-client/queues';
import { alpha, Box, Paper, Stack, Switch } from '@rossum/ui/material';

type Props = {
  queue: QueueType;
  active: boolean;
  onToggle: (active: boolean) => void;
};

const Queue = ({ queue, active, onToggle }: Props) => (
  <Paper
    sx={{
      py: 2,
      px: 3,
      backgroundColor: t =>
        active
          ? t.palette.background.paper
          : alpha(t.palette.background.paper, t.palette.action.disabledOpacity),
    }}
  >
    <Stack direction="row" alignItems="center" justifyContent="space-between">
      <Stack direction="row" spacing={2} alignItems="center">
        <Box
          sx={{
            backgroundColor: t =>
              active ? t.palette.primary.main : t.palette.action.disabled,
            borderRadius: '50px',
            width: '10px',
            height: '10px',
          }}
        />
        <span>{queue.name}</span>
      </Stack>
      <Switch
        checked={active}
        onChange={(_, value) => onToggle(value)}
        size="small"
      />
    </Stack>
  </Paper>
);

export default Queue;
